import React from "react";
import BuscarCep from "../Base/BuscarCep";
import { InputPadrao, LabelPadrao } from "../../../components/Base";
import { Form } from "antd";

export default function EnderecoForm({ object, setObject, required, disableForm, onOk, tabIndex = 0 }) {

  return <div>
    <div style={{ display: "flex", alignItems: "flex-end" }}>
      <div>
        <LabelPadrao>CEP</LabelPadrao>
        <BuscarCep
          tabIndex={tabIndex}
          nextTab={tabIndex + 2}
          disableForm={disableForm}
          cep={object.cep}
          setCep={e => setObject({ ...object, cep: e })}
          required={required}
          onOk={endereco => {
            if (endereco)
              setObject({ bairro: endereco.bairro, logradouro: endereco.logradouro, uf: endereco.uf, codigoIbge: endereco.ibge, cidade: endereco.localidade, cep: endereco.cep });
          }} />
      </div>
    </div>
    <div>
      <div style={{ flex: 1, display: "flex" }}>
        <div style={{ width: "45%" }}>
          <LabelPadrao>Logradouro</LabelPadrao>
          {!disableForm ? <Form.Item name="logradouro" rules={[{ type: "string", message: "Insira o logradouro", required: required, whitespace: true, }]}>
            <InputPadrao placeholder="Insira o logradouro" maxLength={60} value={object.logradouro} onChange={e => setObject({ ...object, logradouro: e.target.value })} tabIndex={tabIndex + 1} />
          </Form.Item> :
            <InputPadrao placeholder="Insira o logradouro" maxLength={60} value={object.logradouro} onChange={e => setObject({ ...object, logradouro: e.target.value })} tabIndex={tabIndex + 1} />}
        </div>
        <div style={{ width: "10%", margin: "0 10px" }}>
          <LabelPadrao>Número</LabelPadrao>
          {!disableForm ? <Form.Item name="numero" rules={[{ type: "string", message: "Insira o número", required: required, whitespace: true, }]}>
            <InputPadrao placeholder="Número" data-cy="input-numero" maxLength={50} value={object.numero} onChange={e => setObject({ ...object, numero: e.target.value })} tabIndex={tabIndex + 2} />
          </Form.Item> :
            <InputPadrao placeholder="Número" data-cy="input-numero" maxLength={50} value={object.numero} onChange={e => setObject({ ...object, numero: e.target.value })} tabIndex={tabIndex + 2} />}
        </div>
        <div style={{ width: "45%" }}>
          <LabelPadrao>Complemento</LabelPadrao>
          <InputPadrao
            placeholder="Insira o complemento"
            data-cy="input-complemento"
            maxLength={50}
            style={{ width: "100%" }}
            value={object.complemento}
            onChange={e => setObject({ ...object, complemento: e.target.value })}
            tabIndex={tabIndex + 3}
            onPressEnter={() => !!onOk && onOk()}
          />
        </div>
      </div>
      <div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "25%" }}>
            <LabelPadrao>Bairro</LabelPadrao>
            {!disableForm ? <Form.Item name="bairro" rules={[{ type: "string", message: "Insira o bairro", required: required, whitespace: true }]}>
              <InputPadrao placeholder="Insira o bairro" maxLength={50} value={object.bairro} onChange={e => setObject({ ...object, bairro: e.target.value })} tabIndex={tabIndex + 4} />
            </Form.Item> :
              <InputPadrao placeholder="Insira o bairro" maxLength={50} value={object.bairro} onChange={e => setObject({ ...object, bairro: e.target.value })} tabIndex={tabIndex + 4} />}
          </div>
          <div style={{ margin: "0px 10px", width: "55%" }}>
            <LabelPadrao>Cidade</LabelPadrao>
            {!disableForm ? <Form.Item name="cidade" rules={[{ type: "string", message: "Insira a cidade", required: required, whitespace: true, }]}>
              <InputPadrao placeholder="Insira a cidade" maxLength={50} value={object.cidade} onChange={e => setObject({ ...object, cidade: e.target.value })} tabIndex={tabIndex + 5} />
            </Form.Item> :
              <InputPadrao placeholder="Insira a cidade" maxLength={50} value={object.cidade} onChange={e => setObject({ ...object, cidade: e.target.value })} tabIndex={tabIndex + 5} />}
          </div>
          <div style={{ width: "5%" }}>
            <LabelPadrao>UF</LabelPadrao>
            {!disableForm ? <Form.Item name="uf" rules={[{ type: "string", message: "UF", required: required, whitespace: true, }]}>
              <InputPadrao placeholder="UF" maxLength={2} value={object.uf} onChange={e => setObject({ ...object, uf: e.target.value })} tabIndex={tabIndex + 6} />
            </Form.Item> :
              <InputPadrao placeholder="UF" maxLength={2} value={object.uf} onChange={e => setObject({ ...object, uf: e.target.value })} tabIndex={tabIndex + 6} />}
          </div>
          <div style={{ marginLeft: 10, width: "15%" }}>
            <LabelPadrao>IBGE</LabelPadrao>
            {!disableForm ? <Form.Item name="codigoIbge" rules={[{ type: "string", message: "Insira o IBGE", required: required, whitespace: true }]}>
              <InputPadrao maxLength={10} placeholder="Insira o IBGE" value={object.codigoIbge} onChange={e => setObject({ ...object, codigoIbge: e.target.value })} tabIndex={tabIndex + 7} />
            </Form.Item> :
              <InputPadrao maxLength={10} value={object.codigoIbge} placeholder="Insira o IBGE" onChange={e => setObject({ ...object, codigoIbge: e.target.value })} tabIndex={tabIndex + 7} />}
          </div>
        </div>
      </div>
    </div>
  </div>;
}
